import { AlignmentInteractions } from "features/alignment/alignmentInteractions";
import { TemporaryCoordinateLabelOverlay } from "features/coordinates";
import { MeasureInteractions } from "features/measure/measureInteractions";

export function Engine2DInteractions() {
    return (
        <>
            <MeasureInteractions />
            <TemporaryCoordinateLabelOverlay />
            <AlignmentInteractions />
        </>
    );
}
